import { createContext, useContext } from 'react';
import { SideMenuState, ToolboxState, SearchLabelState, AnnotationsState } from '@/components/Layout';
import { ToolboxViews } from '@/components/Toolbox';
import { SubjectViewState } from '@/components/ThreeDeeViewer/Experience/Subject';
import { LabelConfig } from '#server/models';

export interface LayoutContextValue {
  sideMenuState: SideMenuState;
  setSideMenuState: React.Dispatch<React.SetStateAction<SideMenuState>>;
  subjectViewState: SubjectViewState;
  setSubjectViewState: React.Dispatch<React.SetStateAction<SubjectViewState>>;
  toggleResetView: () => void;
  setToolboxView: (view: ToolboxViews) => void;
  toolboxState: ToolboxState;
  searchLabelsState: SearchLabelState;
  getUpdatedLabels: () => LabelConfig[];
  headerHeight: number;
  annotationsState: AnnotationsState;
  setAnnotationsState: React.Dispatch<React.SetStateAction<AnnotationsState>>;
}

export const LayoutContext = createContext<LayoutContextValue | null>(null);

export function useLayoutContext() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutContext.Provider');
  }
  return context;
}
